import React from 'react';
import PropTypes from 'prop-types';

import * as FilePreviews from './FilePreviews';
import * as FileWrappers from './FileWrappers';

const KEY_CODE = {
  LEFT: 37,
  RIGHT: 39,
};
const VISIBLE_INDICATORS_COUNT = 8;

export default class FileViewer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeIndex: props.activeIndex,
    };

    this.container = undefined;
    this.mounted = undefined;
  }

  getPreviewComponent = file => {
    switch (file.type || file.getType()) {
      case 'doc':
        return <FilePreviews.Doc file={file} />;
        break;

      case 'img':
        return <FilePreviews.Img file={file} />;
        break;
    }
  };

  getWrapperComponent = () => {
    const indexText = this.state.activeIndex + 1 + '/' + this.props.files.length;
    const shownIndex = this.props.shownIndex;
    const file = this.props.files[this.state.activeIndex];

    switch (file.type || file.getType()) {
      case 'img':
        return <FileWrappers.Img shownIndex={shownIndex} index={indexText} image={file} />;
        break;

      case 'doc':
        switch (file.extension || file.getExtension()) {
          case 'pdf':
            return <FileWrappers.Pdf shownIndex={shownIndex} index={indexText} file={file} />;
            break;
        }
        break;
    }

    return null;
  };

  renderIndicators = list => {
    const activeIndex = this.state.activeIndex;
    const ret = Math.round(VISIBLE_INDICATORS_COUNT / 2);
    const length = list.length;
    return list.map((item, index) => {
      const isActive = activeIndex === index;
      const itemInvisible =
        length > VISIBLE_INDICATORS_COUNT &&
        (index < Math.min(length - VISIBLE_INDICATORS_COUNT - 1, activeIndex - ret) ||
          index > Math.max(activeIndex + ret, VISIBLE_INDICATORS_COUNT));

      const itemCls =
        'indicators-item ' +
        (isActive ? 'active ' : '') +
        (itemInvisible ? 'invisible ' : '') +
        (this.props.showPreview ? 'preview ' : '');

      return (
        <div key={index} class={itemCls} onClick={() => this.itemControl(index)}>
          {this.props.showPreview ? this.getPreviewComponent(item) : null}
        </div>
      );
    });
  };

  onPrev = () => {
    let index = (this.state.activeIndex + this.props.files.length - 1) % this.props.files.length;
    this.itemControl(index);
  };

  onNext = () => {
    let index = (this.state.activeIndex + 1) % this.props.files.length;
    this.itemControl(index);
  };

  itemControl = index => {
    if (index === this.state.activeIndex) {
      return;
    }
    this.setState({ activeIndex: index });
  };

  onKeyDown = e => {
    if (!this.mounted) {
      return;
    }

    switch (e.which || e.keyCode) {
      case KEY_CODE.LEFT:
        e.stopPropagation();
        this.onPrev();
        break;

      case KEY_CODE.RIGHT:
        e.stopPropagation();
        this.onNext();
        break;
    }
  };

  componentDidMount = () => {
    this.mounted = true;
    document.documentElement.addEventListener('keydown', this.onKeyDown);
  };

  componentWillUnmount = () => {
    this.mounted = false;
    document.documentElement.removeEventListener('keydown', this.onKeyDown);
  };

  render() {
    const { files, shownIndex, prefixCls } = this.props;
    const { activeIndex } = this.state;
    const indicatorVisible = files.length > 1;

    return (
      <div class={'react-image-viewer ' + prefixCls + '-image-viewer'} ref={component => (this.container = component)}>
        {this.getWrapperComponent()}

        {indicatorVisible ? (
          <div class="direction-control-button">
            <div class="prev-button button" onClick={this.onPrev}>
              <div class="bar" />
            </div>
            <div class="next-button button" onClick={this.onNext}>
              <div class="bar" />
            </div>
            <div class="indicators">{indicatorVisible && this.renderIndicators(files)}</div>
          </div>
        ) : null}
      </div>
    );
  }
}
FileViewer.defaultProps = {
  prefixCls: 'react-file-viewer',
  shownIndex: true,
  showPreview: true,
  activeIndex: 0,
};
FileViewer.propTypes = {
  prefixCls: PropTypes.string,
  shownIndex: PropTypes.bool,
  showPreview: PropTypes.bool,
  activeIndex: PropTypes.number,
};
